module.exports = __webpack_public_path__ + "static/sport/register-success-new.e98d23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/register-success-new.png
// module id = 9KgG
// module chunks = 0